import { render } from "./CardThirtyEight.vue?vue&type=template&id=141e7368"
import script from "./CardThirtyEight.vue?vue&type=script&lang=js"
export * from "./CardThirtyEight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__